(() => {
  const HANDLE = "ironnest-system-circle-heavy-frame-version";

  // tylko na tym produkcie
  if (!location.pathname.includes(`/products/${HANDLE}`)) return;

  // 1) najpierw spróbuj po nagłówku (Twoje: "Enter your exact measurements (required)")
  const targets = Array.from(document.querySelectorAll("h1,h2,h3,h4,legend,strong,p,label"))
    .filter(el => (el.textContent || "").toLowerCase().includes("enter your exact measurements"));

  if (targets.length) {
    const box = targets[0].closest("div,fieldset,section,article,form");
    if (box) box.style.display = "none";
  }

  // 2) fallback: ukryj typowe kontenery custom fields / line item properties
  const selectors = [
    ".product__custom-fields",
    ".product-form__input",
    "fieldset",
    "[data-custom-field]",
    "[data-line-item-property]"
  ];

  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(node => {
      const txt = (node.textContent || "").toLowerCase();
      if (txt.includes("enter your exact measurements")) node.style.display = "none";
    });
  });
})();